module.exports = __webpack_public_path__ + "img/normal.b1480006.png";